if (process.env.NODE_ENV === "production") {
  module.exports = {
    backendurl: process.env.VUE_APP_BACKEND_URL_PRODUCTION,
    productionurl: process.env.VUE_APP_PRODUCTION_URL,
  };
} else {
  module.exports = {
    backendurl: "http://localhost:5000",
    productionurl: "http://localhost:8080",
  };
}
//
